// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"169":"167374ad","467":"1a7a8b74","557":"39962b14","622":"de7df13c","787":"a1537ef3"}[chunkId] + ".chunk.js";
};